import { useMemo } from "react"

import { useHours } from "modules/Booking/components/TimeRequestModal/hooks/useHours"
import { AvailableLocalHours } from "modules/Booking/components/TimeRequestModal/common/interfaces"
import { TimeRequestSelectors, UtcTime } from "modules/Booking/common/interfaces"
import { formatTodME, formatToHoursAndMinutes } from "utils/datetime-format-utils"
import { Dropdown, Img, Text } from "ui-kit/components-branded/index"

interface Props {
    items: TimeRequestSelectors[]
    item: TimeRequestSelectors
    index: number
    utcTime: UtcTime | null
    disabled?: boolean
    psyHashId: string
    slots?: AvailableLocalHours
    onClickDate: (value: string, index: number) => void
    onClickTime: (time: string, index: number) => void
}

export function Item({
    items,
    item,
    index,
    utcTime,
    disabled,
    slots,
    onClickDate,
    onClickTime,
}: Props) {
    const hours = useHours(item.date, slots)

    const availableTime = useMemo(() => {
        let findTime = item.date && utcTime && utcTime[item.date] ? utcTime[item.date] : []

        findTime = findTime.filter(
            (time) => !items.some((t) => item.date === t.date && t.time === time)
        )

        if (findTime?.length === 0 && item.time) {
            findTime = [item.time]
        }

        return findTime
    }, [item, items, utcTime])

    const disabledDate = useMemo(
        () => (index > 0 ? items[index - 1]?.time || items[index]?.date : true),
        [items, index]
    )

    const dates = useMemo(() => {
        const dates = { ...utcTime }

        for (const key in dates) {
            const length = items.reduce((acc, item) => {
                const findItem = dates[key].find((time) => time === item.time && key === item.date)
                if (findItem) {
                    acc++
                }
                return acc
            }, 0)

            if (length === dates[key].length) {
                delete dates[key]
            }
        }

        return dates
    }, [utcTime, items])

    const hourLabel = () => {
        if (item.date && item.time)
            return formatToHoursAndMinutes(new Date(`${item.date} ${item.time}`))
        else return "Время"
    }

    return (
        <div className="date-time-container is-flex">
            <Dropdown
                label={item.date ? formatTodME(new Date(item.date)) : "День"}
                wrapperClassName="date-time-dropdown__wrapper"
                isDisabled={disabled ?? !disabledDate}
                idContainer={"time-request-modal"}
            >
                {Object.keys(dates)
                    .sort((a, b) => new Date(a).getTime() - new Date(b).getTime())
                    .map((key, i) => (
                        <Dropdown.Item
                            onClick={() => {
                                onClickDate(key, index)
                            }}
                            key={i}
                        >
                            {formatTodME(new Date(key))}
                        </Dropdown.Item>
                    ))}
            </Dropdown>
            <Dropdown
                label={hourLabel()}
                wrapperClassName="date-time-dropdown__wrapper"
                isDisabled={disabled ? disabled : !item.date}
                idContainer={"time-request-modal"}
            >
                {availableTime && item.date
                    ? availableTime.map((time, i) => {
                          return (
                              <Dropdown.Item onClick={() => onClickTime(time, index)} key={i}>
                                  <div className="date-time-dropdown__item-hour">
                                      {item.date &&
                                          formatToHoursAndMinutes(
                                              new Date(`${item.date} ${time}`)
                                          )}{" "}
                                      {hours.includes(time) && (
                                          <>
                                              <Text className="date-time-dropdown__hour-notify">
                                                  &nbsp;Мгновенная запись
                                              </Text>
                                              <Img
                                                  src="zap24x24.png"
                                                  className="date-time-dropdown__emoji"
                                              />
                                          </>
                                      )}
                                  </div>
                              </Dropdown.Item>
                          )
                      })
                    : null}
            </Dropdown>
        </div>
    )
}
